import { mode, PaymentMode } from '~/hooks/usePaymentMode';
import { useVendorBillsPay } from './useVendorBillsPay';
import { useVendorBillsPortal } from './useVendorBillsPortal';
import type { GetVendorBillsToPayParams, GetVendorBillsToSettleParams } from '~/swagger/portal/Api';
import type { PayVendorBillsStoreData } from '~/types/payVendorBills';

export function useVendorBillsByMode() {
  const portal = mode() === PaymentMode.Portal ? useVendorBillsPortal() : null;
  const pay = mode() === PaymentMode.Pay ? useVendorBillsPay() : null;

  const fetchBills = (filter?: GetVendorBillsToPayParams | GetVendorBillsToSettleParams) => {
    if (mode() === PaymentMode.Portal && portal) {
      return portal.fetchBills(filter as GetVendorBillsToPayParams);
    }
    if (mode() === PaymentMode.Pay && pay) {
      return pay.fetchBills(filter as GetVendorBillsToSettleParams);
    }
    return Promise.reject(new Error('No vendor bills hook available for current payment mode'));
  };

  const payBills = (storeData: PayVendorBillsStoreData) => {
    if (mode() === PaymentMode.Portal && portal) {
      return portal.payBills(storeData);
    }
    if (mode() === PaymentMode.Pay && pay) {
      return pay.payBills(storeData);
    }
    return Promise.reject(new Error('No vendor bills hook available for current payment mode'));
  };

  return { mode, fetchBills, payBills };
}
